import '../CreateEditDialog.scss';

import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import useAxiosHook from '../../../../../../../hooks/useAxiosHook';
import { WithData } from '../../../../../../../types/api';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';

function Regions() {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const values = watch();

  const { data: regionsData, isLoading } = useAxiosHook<
    WithData<{ id: number; name: string }[]>
  >('/hubs/regions-not-assigned');

  const regions = useMemo(() => {
    const map = new Map<number, any>();

    (regionsData?.data || []).forEach((r) => {
      map.set(r.id, r);
    });

    (values.regions || []).forEach((r: any) => {
      map.set(r.id, r);
    });

    return Array.from(map.values());
  }, [regionsData]); // ❗ НЕ зависи од values.regions

  return (
    <>
      <p className="mt-0">
        {t('Select the regions you want assigned to this warehouse')}
      </p>

      {isLoading ? (
        <div className="text-center">
          <ProgressSpinner style={{ width: 72 }} />
        </div>
      ) : (
        <FieldWithErrors name="regions" label={false}>
          <Controller
            name="regions"
            render={({ field }) => {
              const toggleRegion = (region: any) => {
                const exists = values?.regions.some(
                  (r: any) => r.id === region.id
                );

                if (exists) {
                  field.onChange(
                    values.regions.filter((r: any) => r.id !== region.id)
                  );
                } else {
                  field.onChange([...values.regions, region]);
                }
              };

              return (
                <div className="p-fluid">
                  {regions.map((region, idx) => (
                    <div className="checkbox-container" key={region.id}>
                      <Checkbox
                        inputId={`region-${region.id}`}
                        checked={values.regions.some(
                          (r: any) => r.id === region.id
                        )}
                        onChange={() => toggleRegion(region)}
                      />
                      <label
                        htmlFor={`region-${region.id}`}
                        data-cy={`regions-${idx}`}
                      >
                        {region.name}
                      </label>
                    </div>
                  ))}
                </div>
              );
            }}
          />
        </FieldWithErrors>
      )}
    </>
  );
}
export default Regions;
